module.exports = __webpack_public_path__ + "img/12.821ef560.png";